import React, { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import { Box, Grid, Card, CardContent, Typography, CardMedia } from '@mui/material';

const CountUpCards = () => {
	const location = window.location.pathname;
	const cardData = [
		{
			title: 'Happy Customers',
			value: 1200,
			icon: '/assets/counter-cards/happy-customer.svg',
		},
		{ title: 'Expert Staffs', value: 150, icon: '/assets/counter-cards/expert-staff.svg' },
		{
			title: 'Years Of Experience',
			value: 43,
			icon: '/assets/counter-cards/year-of-experience.svg',
		},
		{
			title: 'Events Completed',
			value: 2575,
			icon: '/assets/counter-cards/events-completed.svg',
		},
	];

	const [isVisible, setIsVisible] = useState(false);
	const [hasAnimated, setHasAnimated] = useState(false);
	const observer = useRef(
		new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting && !hasAnimated) {
				setIsVisible(true);
				setHasAnimated(true);
			}
		})
	);

	const cardRef = useRef(null);

	useEffect(() => {
		const currentRef = cardRef.current;
		if (currentRef) {
			observer.current.observe(currentRef);
		}

		return () => {
			if (currentRef) {
				observer.current.unobserve(currentRef);
			}
		};
	}, []);

	return (
		<Box style={{ position: 'relative', zIndex: 0 }}>
			<CardMedia
				component="img"
				image={
					location === '/about-us'
						? '/events/group-south-indian-food-like-masala-dosa-uttapam-idli-idly-wada-vada-sambar-appam-semolina-halwa-upma-served-banana-leaf-with-colourful-chutneys.png'
						: '/events/Mask group.png'
				}
				alt="Brush Image"
				sx={{
					width: '35vw',
					height: 'auto',
					objectFit: 'contain',
					position: 'absolute',
					top: { xs: 10, md: '0px', lg: '-45px' },
					// bottom: '250px',
					zIndex: 2,
					display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' },
				}}
			/>

			<Box
				ref={cardRef}
				sx={{
					padding: '3rem 0rem',
					backgroundImage: 'url(/assets/counter-banner.svg)',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					position: 'relative',
				}}
			>
				<Grid container spacing={2}>
					<Grid size={{ xs: 12, sm: 6, md: 4 }} />
					<Grid size={{ xs: 12, sm: 12, md: 8 }}>
						<Grid container spacing={2}>
							{cardData.map((data, index) => (
								<Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
									<Card
										sx={{
											textAlign: 'center',
											p: 1,
											boxShadow: 3,
											minWidth: 160,
											maxWidth: 260,
											minHeight: 120,
											maxHeight: 180,
											display: 'flex',
											flexDirection: 'column',
											justifyContent: 'center',
											margin: 'auto',
											marginTop: {
												xs: '0px',
												sm: index % 2 === 0 ? '0px' : '35px',
											},
										}}
									>
										<CardContent>
											<img
												src={data.icon}
												alt={data.title}
												style={{
													width: '50px',
													height: '50px',
													marginBottom: '10px',
												}}
											/>
											<Typography variant="h4" component="div">
												{isVisible ? (
													<CountUp
														end={data.value}
														duration={2.75}
														start={0}
													/>
												) : (
													0
												)}
											</Typography>
											<Typography variant="body1">{data.title}</Typography>
										</CardContent>
									</Card>
								</Grid>
							))}
						</Grid>
					</Grid>
				</Grid>
			</Box>
			{location === '/about-us' ? (
				<></>
			) : (
				<Box
					component="img"
					src="/events/delicious-ice-cream-flavours-arrangement.png"
					alt="Ice Cream"
					sx={{
						display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
						position: 'absolute',
						top: { xs: 10, md: 20, lg: -40 },
						right: { xs: 10, md: 0 },
						width: { xs: 80, md: 140 },
						zIndex: 1,
					}}
				/>
			)}
		</Box>
	);
};

export default CountUpCards;
